import { render, staticRenderFns } from "./CommRegion.vue?vue&type=template&id=214bf40a&scoped=true"
import script from "./CommRegion.vue?vue&type=script&lang=js"
export * from "./CommRegion.vue?vue&type=script&lang=js"
import style0 from "./CommRegion.vue?vue&type=style&index=0&id=214bf40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214bf40a",
  null
  
)

export default component.exports